export function splitVerseLines(text) {
  if (!text) return [];
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function tokenizeLine(line) {
  if (!line) return [];
  return line.split(/\s+/).filter(Boolean);
}

export function flattenVerseWords(text) {
  const lines = splitVerseLines(text);
  const words = [];
  lines.forEach((line, lineIdx) => {
    tokenizeLine(line).forEach((word) => {
      words.push({ word, lineIdx });
    });
  });
  return words;
}

export function tokenizeParagraph(text) {
  if (!text) return [];
  return text
    .replace(/\n/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .map((word, index) => ({ word, lineIdx: 0, globalIndex: index }));
}
